import { render, staticRenderFns } from "./Deallog.vue?vue&type=template&id=e1961e94"
import script from "./Deallog.vue?vue&type=script&lang=js"
export * from "./Deallog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports